/**
 * MAGSDK basic implementation of ufs plugin.
 *
 * @author Igor Zaporozhets <i.zaporozhets@infomir.com>
 */

'use strict';


var Ufs = require('./ufs');

/**
 * Resolve own ufs wrapper for each application.
 *
 * @param {Object} config application config
 *
 * @return {Ufs} ufs wrapper instance
 */
module.exports = {
    onAppInit: function ( config, callback ) {
        callback(null, new Ufs(config.app.packageName));
    }
};
